<template>
  <v-card flat>
    <v-card-text>
      {{$t('labels.loginyou')}}...
    </v-card-text>
  </v-card>
</template>

<script>
import API from '@/services/api'
import { mapActions, mapGetters } from "vuex"

// @group Start
// LoginReturn component
export default {
name: 'LoginReturn',
  data: () => ({
    session: null
  }),

  methods: {
    ...mapActions('currentuser', [ 'setCurrentUser' ])
  },
  /**
   * @vuese
   * Used to make a login with bank id
   * @arg The argument is an integer representing bank id
   */
  created() {
    this.session=this.$route.query.grandidsession

    API.bankIdLogin({sessionId: this.session})
    .then(res => {
       /**
       * @vuese
       * Used to set  current user in the local store
       */
      this.setCurrentUser(res.data)
      this.$nextTick(() => {
        this.$router.push({ name: "Start" });
      })
    })
    .catch(err => {
      if (err && err.response && err.response.data) {
        console.log(err.response.data.error ? err.response.data.error : err.response.data)
      }
    })

  }
}
</script>

<style>

</style>